import React, { useState } from "react"

import { AnimatedModal } from "./Modal"
import Typography from "./Typography"

export default function ArchiveIntakeFormSubmissionModal({ visible, formName, loading = false, onClose, onConfirm }) {
  const [confirming, setConfirming] = useState(false)

  const handleConfirm = async () => {
    setConfirming(true)
    try {
      await onConfirm()
    } finally {
      setConfirming(false)
    }
  }

  const busy = loading || confirming

  return (
    <AnimatedModal
      visible={visible}
      hideModal={onClose}
      header="Delete intake response"
      showFooter
      hideSaveButton
      hideCancelButton
      footerButtons={[
        {
          label: "Cancel",
          type: "tertiary",
          onClick: onClose,
          disabled: busy
        },
        {
          label: busy ? "Deleting…" : "Delete",
          type: "warning",
          onClick: handleConfirm,
          disabled: busy
        }
      ]}>
      <Typography variant="body" as="p">
        Delete the completed response for
        {formName ? (
          <>
            {" "}
            <span className="font-semibold">{formName}</span>
          </>
        ) : null}
        ? The client can submit this form again later. You can still send them a new link from this page.
      </Typography>
    </AnimatedModal>
  )
}
